var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    "data-name": "Rectangle 575",
    width: 36,
    height: 36,
    transform: "translate(25 606)",
    fill: "#e6e6e6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(-25 -606)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_001-google",
    "data-name": "001-google",
    transform: "translate(25 606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M8.438,15.651a9.5,9.5,0,0,1,1.345-4.885V4.7H3.714a18.009,18.009,0,0,0,0,21.907H9.783V20.536A9.5,9.5,0,0,1,8.438,15.651Z",
    transform: "translate(0 2.349)",
    fill: "#fbbd00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M13.406,18.821,9.188,23.04l4.219,4.219A17.864,17.864,0,0,0,24.36,23.545V17.483H18.3A9.561,9.561,0,0,1,13.406,18.821Z",
    transform: "translate(4.594 8.741)",
    fill: "#0f9d58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M8.545,15.257,2.476,21.325A18.287,18.287,0,0,0,4.034,23.1a17.882,17.882,0,0,0,12.728,5.272V19.934a9.566,9.566,0,0,1-8.217-4.677Z",
    transform: "translate(1.238 7.628)",
    fill: "#31aa52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M30,13.375a18.158,18.158,0,0,0-.295-3.261l-.158-.865H12v8.437h8.54A9.519,9.519,0,0,1,16.891,21.6l6.062,6.062A18.287,18.287,0,0,0,24.728,26.1,17.882,17.882,0,0,0,30,13.375Z",
    transform: "translate(6 4.625)",
    fill: "#3c79e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M20.168,11.238l.746.746L26.88,6.018l-.746-.746A17.882,17.882,0,0,0,13.406,0L9.187,4.219l4.219,4.219A9.5,9.5,0,0,1,20.168,11.238Z",
    transform: "translate(4.594 0)",
    fill: "#cf2d48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M16.762,8.438V0A17.883,17.883,0,0,0,4.034,5.272,18.271,18.271,0,0,0,2.476,7.046l6.069,6.069a9.567,9.567,0,0,1,8.217-4.677Z",
    transform: "translate(1.238 0)",
    fill: "#eb4132"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.545d3696f40dc542a8d08305e7936115.svg";
export { ForwardRef as ReactComponent };